import { sendWebsocketMessage } from '../../../../../App';
/**
 * If a user "paper trades (live ds, simulated account/brokerage")" through us,
 *  there results are added to an account that starts with $100,000. If they lose all
 * there money, they can reset their account to $100,000 with this message
 */

export function resetSimAccount() {
    const msg = {
        accountId: "BACKTEST",
        messageType: "resetSimAccount",
    };
    sendWebsocketMessage(msg);
}